module.exports = __webpack_public_path__ + "img/zchr.d76bb51.png";